import axios_req from '../axios'
let getFriendlyLinks = (data) => axios_req('post', '/dg/link', data, 1) 

export  {
  getFriendlyLinks
}
